export const formatCurrency = (number, { locale = 'it-IT', currency = 'EUR' } = {}) =>
    new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
    }).format(number);
